import { Controller } from "@hotwired/stimulus";
import { Target, TypedController, Value } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller<HTMLDivElement> {
  declare hasCopyIconTarget: boolean;
  declare hasCheckIconTarget: boolean;
  @Target copyIconTarget?: HTMLSpanElement;
  @Target checkIconTarget?: HTMLSpanElement;

  @Value(String) copyValue: string;
  declare hasCopyValue: boolean;

  copy() {
    navigator.clipboard.writeText(this.content).then(() => {
      if (this.hasCopyIconTarget && this.hasCheckIconTarget) {
        this.changeIcon();

        setTimeout(() => {
          this.resetIcon();
        }, 3000);
      }
    });
  }

  private changeIcon() {
    this.copyIconTarget!.classList.add("hidden");
    this.checkIconTarget!.classList.remove("hidden");
  }

  private resetIcon() {
    this.copyIconTarget!.classList.remove("hidden");
    this.checkIconTarget!.classList.add("hidden");
  }

  private get content() {
    if (this.hasCopyValue) {
      return this.copyValue;
    }

    return this.element.querySelector<HTMLDivElement>(".copy-content-container")!.innerText;
  }
}
